import { render, staticRenderFns } from "./ModuleThree.vue?vue&type=template&id=496e2626&scoped=true"
import script from "./ModuleThree.vue?vue&type=script&lang=js"
export * from "./ModuleThree.vue?vue&type=script&lang=js"
import style0 from "./ModuleThree.vue?vue&type=style&index=0&id=496e2626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e2626",
  null
  
)

export default component.exports